import { useContext, useState } from "react";
import { InvoiceGetResponse } from "./entities/InvoiceGetResponse";
import { TranslationService } from "../../../services/TranslationService";
import ToastContext from "../../shared/bootstrap/Toast";
import Dropdown from "../../shared/components/Dropdown";
import CompanyService from "../../../services/CompanyService";
import InvoiceService, {
  InvoiceFields
} from "../../../services/InvoiceService";
import { getError } from "../../../utils/RequestUtils";
import {
  PaymentStatus,
  PaymentStatusNames
} from "../../../entities/company/PaymentProvider/PaymentStatus";

export const InvoiceDetailPaymentStatus = ({
  invoice,
  isEditing,
  afterSubmit,
  editingChanged,
  canEdit = true
}: {
  invoice: InvoiceGetResponse.Item;
  isEditing: boolean;
  afterSubmit: () => void;
  editingChanged: (editing: boolean) => void;
  canEdit?: boolean;
}) => {
  const { showToast } = useContext(ToastContext);
  const { translate } = TranslationService;
  const [isSaving, setIsSaving] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(
    invoice.PaymentStatus ?? PaymentStatus.Pending
  );

  const statusList = [
    {
      value: PaymentStatus.Pending,
      text: PaymentStatusNames[PaymentStatus.Pending]
    },
    {
      value: PaymentStatus.InProcess,
      text: PaymentStatusNames[PaymentStatus.InProcess]
    },
    {
      value: PaymentStatus.Approved,
      text: PaymentStatusNames[PaymentStatus.Approved]
    },
    {
      value: PaymentStatus.Rejected,
      text: PaymentStatusNames[PaymentStatus.Rejected]
    }
  ];

  const currentStatusText =
    PaymentStatusNames[invoice.PaymentStatus ?? PaymentStatus.Pending];

  const statusChange = (value: number) => {
    setSelectedStatus(value);
  };

  const onSubmit = async () => {
    setIsSaving(true);
    try {
      const result = await InvoiceService.setField(
        invoice.IOID,
        InvoiceFields.paymentStatus.toString(),
        selectedStatus.toString()
      );

      if (result instanceof Error) {
        showToast(getError(result), undefined, "danger");
        return;
      }

      showToast(translate.SavedSuccessfully, undefined, "success");
      editingChanged(false);
      afterSubmit && afterSubmit();
    } catch (e: any) {
      showToast(e?.message ?? "Error al guardar", undefined, "danger");
    } finally {
      setIsSaving(false);
    }
  };

  const content = isEditing ? (
    <div className="d-flex input-row mb-3">
      <label className="form-label">{translate.PaymentStatus}</label>
      <div className="show-child-on-hover ml-auto">
        <div className="row">
          <div className="col-auto">
            <i
              className="far fa-times text-danger"
              style={{ marginTop: 10 }}
              onClick={() => editingChanged(false)}
            ></i>
            {isSaving && (
              <i className="fas fa-spinner-third fa-spin third ms-2"></i>
            )}
          </div>
          <div className="col-auto">
            <Dropdown
              optionLabel={translate.Select}
              onChange={statusChange}
              items={statusList}
              defaultValue={selectedStatus}
            />
          </div>
          <div className="col-auto">
            <button className="btn btn-success" onClick={onSubmit}>
              {translate.Save}
            </button>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="d-flex input-row mb-3">
      <label className="form-label">{translate.PaymentStatus}</label>
      <div className="show-child-on-hover ml-auto">
        <div className="row">
          {canEdit &&
            CompanyService.canDo("editio") &&
            !CompanyService.getSetting("hideeditio") && (
              <div className="col-auto">
                <i
                  className="pointer hideOnPrint far show-when-hovering-parent"
                  onClick={() => editingChanged(false)}
                ></i>
              </div>
            )}
          <div className="col">
            <p className="form-label-detail">{currentStatusText}</p>
          </div>
        </div>
      </div>
    </div>
  );

  return <>{content}</>;
};

export default InvoiceDetailPaymentStatus;
